cv.TopView = Marionette.LayoutView.extend({
  id: 'tippy-top-wrapper',

  template: cv.Templates['top/view'],

  events : {
    'click #account-link' : 'account'
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    // Listeners
    this.listenTo(cv.user, 'change:photo_path' , this.renderProfilePhoto, this);
    this.listenToOnce(cv.user, 'sync', this.renderProfilePhoto, this);
    this.listenTo(vent, 'section_admin', function(category){
      this.$('#tippy-top .admin-menu a').removeClass('active');
      this.$('#tippy-top .admin-menu #admin-' + category).addClass('active');
    }, this);

    // Set some variables
    this.campaign_id = 0;
    this.project_id = 0;
    this.team_id = 0;
    this.post_id = 0;
    if($('#cv-campaign-id').length > 0){
      this.campaign_id = $('#cv-campaign-id').val();
    }
    if($('#cv-project-id').length > 0){
      this.project_id = $('#cv-project-id').val();
    }
    if($('#cv-team-id').length > 0){
      this.team_id = $('#cv-team-id').val();
    }
    if($('#cv-post-id').length > 0){
      this.post_id = $('#cv-post-id').val();
    }

    console.log('TopView initialized.');
  },

  templateHelpers: function () {
    return {
      is_donation : cv.campaign.get('type') == 'donation' ? true : false,
      is_campaign : !cv.campaign.isNew() && cv.campaign.get('type') == 'campaign' ? true : false,

      in_setup : cv.PRELOADED.group == 'setup' ? true : false,
      in_pay : cv.PRELOADED.group == 'pay' ? true : false,
      in_auth : cv.PRELOADED.group == 'auth' ? true : false,

      logged_in : cv.PRELOADED.logged_in,
      stub : !_.isUndefined(cv.project) ? cv.project.get('stub') : '',
      enable_projects : !_.isUndefined(cv.campaign) && cv.campaign.get('enable_projects') == 1 ? true : false,
      enable_teams : !_.isUndefined(cv.campaign) && cv.campaign.get('enable_teams') == 1 ? true : false,
      url : 'https://' +  cv.campaign.get('url')
    };
  },

  account: function(e){
    e.preventDefault();

    if(cv.PRELOADED.logged_in == false){
      return false;
    }
    
    // If the user isn't setup the redirect them to the setup
    if(!moment(cv.project.get('user_updated')).isValid() || !moment(cv.project.get('project_updated')).isValid()){
      top.location = '/fundraiser_setup';
      return false;
    }

    // If registration is enabled and not paid then redirect to setup
    if(cv.campaign.get('enable_p2p_registrations') == 1 && _.isEmpty(cv.project.get('registration'))){
      top.location = '/fundraiser_setup/registration';
      return false;
    }

    // If we don't have a valid stub then redirect to the setup again
    if(cv.project.get('stub') != ''){
      if(this.project_id == cv.project.get('id')){
        cv.adminRouter.navigate('dashboard', { trigger : true });
      }else{
        top.location = '/' + cv.project.get('stub') + '/admin/dashboard';
      }
    }else{
      top.location = '/fundraiser_setup';
    }
  },

  onAttach: function(){
    // Render the user profile
    if(cv.PRELOADED.logged_in == true){
      this.renderProfilePhoto(cv.user);
    }
    
    // Show the post controls
    if(this.project_id != 0 && this.post_id != 0){
      this.$('.extra-menu').html(cv.Templates['top/top_post']({
        id : this.post_id
      }));
    }

    // Show the fundraiser controls
    if(this.project_id != 0 && this.post_id == 0){
      this.$('.extra-menu').html(cv.Templates['top/top_fundraiser']());
    }
  },

  renderProfilePhoto: function(model){
    var $replace = this.$('.profile-photo').clone();

    $replace.attr('data-src', cv.photo({
      photo_path : model.get('photo_path'),
      photo_default : cv.campaign.get('default_fundraiser_photo'),
      url_only : true,
      transforms : {
        fit : 'crop'
      }
    }));

    this.$('.profile-photo').replaceWith($replace);

    imgix.fluid(this.$el.get(0), {
      updateOnResizeDown: true,
      pixelStep: 5,
      autoInsertCSSBestPractices: true
    });
  }
});
